import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";

class serverLoanLibraryCatalogApi {
    static getLoanLibraryCatalogResources(searchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(searchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog/?${queryParameters}`,
                requestTypes.GET,
            ),
        );
    }

    static getAllLoanLibraryCatalogItems() {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog/all`,
                requestTypes.GET,
            ),
        );
    }

    static getWhatsNew() {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog/whatsnew`,
                requestTypes.GET,
            ),
        );
    }

    static addLoanLibraryCatalogItem(catalogItem: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog`,
                requestTypes.POST,
                JSON.stringify(catalogItem),
                apiConstants.successMessage.loanLibrary.CATALOG_ITEM_ADDED,
            ),
        );
    }

    static updateLoanLibraryCatalogItem(catalogItem: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog`,
                requestTypes.PUT,
                JSON.stringify(catalogItem),
                apiConstants.successMessage.loanLibrary.CATALOG_ITEM_UPDATED,
            ),
        );
    }

    static updateLoanLibraryCatalogItemWithInventory(catalogItemId: string, catalogWithInventory: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog`,
                requestTypes.PUT,
                JSON.stringify(catalogWithInventory),
                apiConstants.successMessage.loanLibrary.CATALOG_ITEM_UPDATED,
            ),
        );
    }

    static deleteLoanLibraryCatalogItem(id: string) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog/${id}`,
                requestTypes.DELETE,
                null,
                apiConstants.successMessage.loanLibrary.CATALOG_ITEM_DELETED,
            ),
        );
    }

    static getInventoryItemByBarCode(barcode: string) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog/inventory/barcode/${barcode}`,
                requestTypes.GET,
            ),
        );
    }

    static getInventoryItemById(id: string) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog/inventory/${id}`,
                requestTypes.GET,
            ),
        );
    }

    static getInventoryItemsForCatalogItem(catalogItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog/${catalogItemId}/inventory`,
                requestTypes.GET,
            ),
        );
    }

    static addInventoryItem(inventoryItem: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog/inventory`,
                requestTypes.POST,
                JSON.stringify(inventoryItem),
                apiConstants.successMessage.loanLibrary.INVENTORY_ITEM_ADDED,
            ),
        );
    }

    static updateInventoryItem(inventoryItem: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog`,
                requestTypes.PUT,
                JSON.stringify(inventoryItem),
                apiConstants.successMessage.loanLibrary.INVENTORY_ITEM_UPDATED,
            ),
        );
    }

    static deleteInventoryItem(id: string) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog/inventory/${id}`,
                requestTypes.DELETE,
                null,
                apiConstants.successMessage.loanLibrary.INVENTORY_ITEM_DELETED,
            ),
        );
    }

    static getManufacturers() {
        return sendRequest(
            requestOptions(config.URL + `manufacturers`,
                requestTypes.GET,
            ),
        );
    }

    static saveManufacturer(manufacturer: Record<string, unknown>) {
        const requestType = manufacturer.manufacturerId ? requestTypes.PUT : requestTypes.POST;
        const requestMessage = manufacturer.manufacturerId
            ? apiConstants.successMessage.loanLibrary.MANUFACTURER_UPDATED
            : apiConstants.successMessage.loanLibrary.MANUFACTURER_ADDED;

        return sendRequest(
            requestOptions(config.URL + `manufacturers`,
                requestType,
                JSON.stringify(manufacturer),
                requestMessage,
            ),
        );
    }
}

export const loanLibraryCatalogApi = config.environment.MODE === config.modes.SERVER ? serverLoanLibraryCatalogApi : serverLoanLibraryCatalogApi;
